import React from 'react'
import CountUp from 'react-countup'

export default function EducationCounter() {
  return (
    <>
        <section className="py-3 bg-primary">
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={300}/>+</h2>
                            <h6 className="counter-head text-light title-dark">Expert Instructor</h6>
                        </div>
                    </div>

                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={108}/>k+</h2>
                            <h6 className="counter-head text-light title-dark">world Students</h6>
                        </div>
                    </div>

                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={10}/>k+</h2>
                            <h6 className="counter-head text-light title-dark">Success Stories</h6>
                        </div>
                    </div>

                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={320}/>+</h2>
                            <h6 className="counter-head text-light title-dark">Trendy Subjects</h6>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    </>
  )
}
